import script from "./GridGeneratorForm.vue?vue&type=script&setup=true&lang=js"
export * from "./GridGeneratorForm.vue?vue&type=script&setup=true&lang=js"

import "./GridGeneratorForm.vue?vue&type=style&index=0&id=60087f8b&scoped=true&lang=css"

import exportComponent from "C:\\Cwiczenia Programowanie Wojtek\\Vue Shop-FCC\\lang-cross\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-60087f8b"]])

export default __exports__